import * as React from 'react';

class SecondWindowPage extends React.Component<{}> {
    handleChange = () => {
        console.log('things are changing');
    };

    render() {
        return <div onChange={this.handleChange}>SecondWindow</div>;
    }
}

export default SecondWindowPage;



// WEBPACK FOOTER //
// ./src/components/common/SecondWindow.tsx